import React from "react";

export default function CyclesIcon({ color, props }) {
  return (
    <svg width={17} height={15} viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.72008 0.777778C6.5193 0.777778 4.52614 1.54778 2.98974 2.8L0 0V7H7.47435L4.468 4.18444C5.62237 3.28222 7.09233 2.72222 8.72008 2.72222C11.66 2.72222 14.1597 4.51889 15.0318 7L17 6.39333C15.8456 3.13444 12.5818 0.777778 8.72008 0.777778Z"
        fill={color}
      />
      <path
        d="M8.27992 14.2222C10.4807 14.2222 12.4739 13.4522 14.0103 12.2L17 15V8H9.52565L12.532 10.8156C11.3776 11.7178 9.90767 12.2778 8.27992 12.2778C5.34001 12.2778 2.84025 10.4811 1.96824 8L-3.8147e-06 8.60667C1.15437 11.8656 4.41817 14.2222 8.27992 14.2222Z"
        fill={color}
      />
    </svg>
  );
}
